export const SIDEBAR_LAYOUT_UPDATED_EVENT = 'sidebar-layout-updated';

export function notifySidebarLayoutUpdated() {
  window.dispatchEvent(new Event(SIDEBAR_LAYOUT_UPDATED_EVENT));
}
